import { SITE_CONFIG } from '../config';

const isValidWebhook = (value) => {
  if (!value || /replace|placeholder|example/i.test(value)) return false;
  try {
    const url = new URL(value);
    return url.protocol === 'https:'
      && url.searchParams.getAll('id').length === 1
      && url.searchParams.getAll('token').length === 1
      && Boolean(url.searchParams.get('id'))
      && Boolean(url.searchParams.get('token'))
      && url.searchParams.get('operation') === 'startbuild';
  } catch {
    return false;
  }
};

export const triggerSiteRebuild = () => {
  const webhook = SITE_CONFIG.AMPLIFY_WEBHOOK;
  if (!isValidWebhook(webhook)) return Promise.resolve(false);
  return fetch(webhook, { method: 'POST', mode: 'no-cors' }).then(() => true);
};
